import React from 'react';

const PageNotFound = () => (
  <div className="GenericText__content">
    <h2>Halt! Access Forbidden!</h2>

    <p>
      You have tried to access something that is not meant for humans. If you
      are a robot, we have made a terrible mistake.
    </p>
  </div>
);

export default PageNotFound;
